// Tick-based interval utilities for consistent game timing
// All intervals are based on 60 FPS ticks (1 tick = ~16.67ms)

// Base tick rate
export const TICK_RATE = 60; // 60 FPS
export const TICK_DURATION_MS = 1000 / TICK_RATE; // ~16.67ms per tick

// Game system intervals in ticks
export const TICK_INTERVALS = {
  // Belt movement - every tick (60 FPS)
  BELT_MOVEMENT: 1,

  PLAYER_MOVEMENT: 10,

  // Miner output processing - every 6 ticks (10 FPS, ~100ms)
  MINER_OUTPUT: 6,

  // Assembler crafting - every 6 ticks (10 FPS, ~100ms)
  ASSEMBLER_CRAFTING: 6,

  // Auto-save - every 1800 ticks (30 seconds at 60 FPS)
  AUTO_SAVE: 1800,
} as const;

// Convert milliseconds to ticks
export const msToTicks = (milliseconds: number): number => {
  return Math.round(milliseconds / TICK_DURATION_MS);
};

// Convert ticks to milliseconds
export const ticksToMs = (ticks: number): number => {
  return ticks * TICK_DURATION_MS;
};

// Convert seconds to ticks
export const secondsToTicks = (seconds: number): number => {
  return Math.round(seconds * TICK_RATE);
};

// Convert ticks to seconds
export const ticksToSeconds = (ticks: number): number => {
  return ticks / TICK_RATE;
};

// Utility to check if a tick count is divisible by an interval
export const isTickInterval = (
  currentTick: number,
  interval: number
): boolean => {
  return currentTick % interval === 0;
};

// Get the next tick when an interval will trigger
export const getNextIntervalTick = (
  currentTick: number,
  interval: number
): number => {
  return currentTick + (interval - (currentTick % interval));
};

// Calculate how many ticks until next interval
export const getTicksUntilNextInterval = (
  currentTick: number,
  interval: number
): number => {
  return interval - (currentTick % interval);
};
